// @mui material components
import {
  Snackbar,
  Alert,
  Grid,
  Card,
  CircularProgress,
  Backdrop,
  Icon,
  Dialog,
  DialogContent,
  DialogActions,
  Divider,
  Container,
} from "@mui/material";

// Material Dashboard 2 React components
import MDBox from "theme/components/MDBox";
import MDTypography from "theme/components/MDTypography";
import MDButton from "theme/components/MDButton";

// Material Dashboard 2 React example components
import DashboardLayout from "app/LayoutContainers/DashboardLayout";
import DashboardNavbar from "app/Navbars/DashboardNavbar";
import Footer from "theme/Footer";

// import { useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import axios from "axios.js";
import DataTable from "theme/Tables/DataTable";
import usePageTitle from "app/pageTitle";
import AppConfig from "appConfig";

function MyCampaigns() {
  const pageTitle = "My Campaigns";
  usePageTitle(pageTitle);

  // const navigate = useNavigate();

  const [showLoading, setShowLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const [errorMsg, setErrMsg] = useState("");
  const [severity, setSeverity] = useState("");
  const handleClose = () => {
    setOpen(false);
    setErrMsg("");
  };

  const [campaigns, setCampaigns] = useState([]);
  const [campaign, setCampaign] = useState(null);
  const [openCampaignDialog, setOpenCampaignDialog] = useState(false);
  const [selectedCampaign, setSelectedCampaign] = useState(null);
  const [loadedCampaign, setLoadedCampaign] = useState(null);

  const tableColumns = [
    { Header: "View", accessor: "view", align: "left" },
    { Header: "Campaign", accessor: "campaign", align: "left" },
    // { Header: "Status", accessor: "status", align: "center" },
    { Header: "Logo", accessor: "icon", align: "left" },
    { Header: "Brand", accessor: "brand", align: "left" },
    // { Header: "Commission", accessor: "commission", align: "left" },
    // { Header: "Joined On", accessor: "created", align: "left" },
  ];

  const buildRateRows = (data) => {
    const rows = [];
    data.map((row) => {
      rows.push({
        view: (
          <MDBox mt={1} variant="button">
            <MDButton
              size="small"
              variant="contained"
              color="info"
              iconOnly
              circular
              onClick={() => {
                setSelectedCampaign(row.reference);
              }}
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                information
              </Icon>
            </MDButton>
          </MDBox>
        ),
        brand: row.account.name,
        icon: <img src={`${AppConfig.api_media_url}${row.account.icon}`} alt="" width="18px" />,
        campaign: row.title,
        // commission: `N${(row.campaign.agent_commission / 100).toLocaleString("en", {
        //   minimumFractionDigits: 2,
        //   maximumFractionDigits: 2,
        // })}`,
        // status: (
        //   <Icon color={row.status ? "success" : "error"}>
        //     {row.status ? "check_circle" : "cancel"}
        //   </Icon>
        // ),
        // created: row.created,
      });
      return null;
    });

    return rows;
  };

  useEffect(() => {
    if (loadedCampaign === null) {
      return;
    }
    setCampaign(loadedCampaign);
    setOpenCampaignDialog(true);
  }, [loadedCampaign]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get(`agents/campaigns/${selectedCampaign}/fetch.json`)
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            setLoadedCampaign(result.data.data.campaign);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg("An error occurred. Please try again in a few moments.");
          setOpen(true);
        });
    };

    if (selectedCampaign !== null) {
      fetchData();
    }
  }, [selectedCampaign]);

  useEffect(() => {
    const fetchData = async () => {
      setShowLoading(true);
      await axios
        .get("agents/campaigns/list.json")
        .then((result) => {
          // console.log(result);
          setShowLoading(false);
          if (result.data.status === "success") {
            const rows = buildRateRows(result.data.data.campaigns);
            setCampaigns(rows);
          } else {
            setSeverity("error");
            setErrMsg(result.data.data.message);
            setOpen(true);
          }
        })
        .catch(() => {
          setShowLoading(false);
          setSeverity("error");
          setErrMsg(
            `Unable to complete request. ${
              navigator.onLine ? "" : "Make sure you have an active internet connection"
            }`
          );
          setOpen(true);
        });
    };

    fetchData();
  }, []);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={showLoading}
        onClick={handleClose}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <Snackbar
        open={open}
        autoHideDuration={6000}
        onClose={handleClose}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert onClose={handleClose} severity={severity} sx={{ width: "100%" }}>
          {errorMsg}
        </Alert>
      </Snackbar>
      {campaign ? (
        <Dialog open={openCampaignDialog} fullWidth maxWidth="sm">
          <DialogContent>
            <Container align="left">
              <MDTypography align="left">
                <MDBox>
                  <MDBox mt={1} mb={2} align="center">
                    <MDTypography variant="h6" fontWeight="medium">
                      <img
                        src={`${AppConfig.api_media_url}${campaign.account.icon}`}
                        alt=""
                        width="24px"
                      />
                      <br />
                      {campaign.account.name}
                    </MDTypography>
                  </MDBox>
                  <MDTypography variant="h6" fontWeight="light">
                    <b>Campaign</b>
                    <br />
                    {campaign.title}
                  </MDTypography>
                  <Divider />
                  <MDTypography variant="h6" fontWeight="medium">
                    Products
                  </MDTypography>
                  {campaign.products.map((product) =>
                    product.status ? (
                      // <MDBox mt={1} align="left">
                      //   <MDBox display="flex" justifyContent="space-between" alignItems="left">
                      //     <MDTypography variant="h6" fontWeight="light">
                      //       {product.title}
                      //     </MDTypography>
                      //     <MDTypography variant="h6" fontWeight="medium" align="right">
                      //       N{product.formatted_price}
                      //     </MDTypography>
                      //   </MDBox>
                      // </MDBox>
                      <MDBox mt={1} mb={3}>
                        <MDBox>
                          <MDTypography variant="h6" fontWeight="light">
                            {product.title}
                          </MDTypography>
                        </MDBox>
                        <MDBox>
                          <MDTypography variant="h6" fontWeight="medium">
                            {campaign.currency.symbol} {product.formatted_price}
                          </MDTypography>
                        </MDBox>
                      </MDBox>
                    ) : (
                      <> </>
                    )
                  )}
                  <Divider />
                  <MDTypography variant="h6" fontWeight="medium">
                    Sales Commissions
                  </MDTypography>
                  {campaign.commissions.length <= 0 ? (
                    <MDBox mt={2} align="left">
                      <MDTypography variant="h6" fontWeight="light">
                        No sales commissions available for campaign.
                      </MDTypography>
                    </MDBox>
                  ) : (
                    <MDBox>
                      {campaign.commissions.map((commission) => (
                        <MDBox mt={1} align="left">
                          <MDBox display="flex" justifyContent="space-between" alignItems="center">
                            <MDTypography variant="h6" fontWeight="light">
                              {commission.product}&nbsp;&nbsp;
                            </MDTypography>
                            <MDTypography variant="h6" fontWeight="light">
                              <strong>
                                {commission.is_commission_percentage ? (
                                  <span>
                                    {(commission.commission * 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                    %
                                  </span>
                                ) : (
                                  <span>
                                    N
                                    {(commission.commission / 100).toLocaleString("en", {
                                      minimumFractionDigits: 2,
                                      maximumFractionDigits: 2,
                                    })}
                                  </span>
                                )}
                              </strong>
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      ))}
                    </MDBox>
                  )}
                  <Divider />
                  <MDTypography variant="h6" fontWeight="medium">
                    Sales Incentives
                  </MDTypography>
                  {campaign.incentives.sales.length <= 0 ? (
                    <MDBox mt={2} align="left">
                      <MDTypography variant="h6" fontWeight="light" fontSize="medium">
                        No sales incentives available for campaign.
                      </MDTypography>
                    </MDBox>
                  ) : (
                    <MDBox>
                      {campaign.incentives.sales.map((incentive) => (
                        <MDBox mt={1} align="left">
                          <MDBox display="flex" justifyContent="space-between" alignItems="center">
                            <MDTypography variant="h6" fontWeight="light" fontSize="medium">
                              {incentive.title} ({incentive.product}) <br />
                              <small>
                                {incentive.sales} sales in {incentive.time_interval} days
                              </small>
                            </MDTypography>
                            <MDTypography
                              variant="h6"
                              fontWeight="light"
                              fontSize="medium"
                              align="right"
                            >
                              {incentive.incentive_type === "DATA" ? (
                                <strong>{incentive.reward}</strong>
                              ) : (
                                <strong>
                                  {incentive.is_reward_commission_percentage ? (
                                    <span>
                                      {(incentive.reward * 100).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}
                                      %
                                    </span>
                                  ) : (
                                    <span>
                                      N
                                      {(incentive.reward / 100).toLocaleString("en", {
                                        minimumFractionDigits: 2,
                                        maximumFractionDigits: 2,
                                      })}
                                    </span>
                                  )}
                                </strong>
                              )}
                              <br />
                              <small>{incentive.incentive_type}</small>
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      ))}
                    </MDBox>
                  )}
                  <Divider />
                  <MDTypography variant="h6" fontWeight="medium">
                    Marketing Material
                  </MDTypography>
                  {campaign.branded_materials.length <= 0 ? (
                    <MDBox mt={2} align="left">
                      <MDTypography variant="h6" fontWeight="light">
                        No materials provided for campaign.
                      </MDTypography>
                    </MDBox>
                  ) : (
                    <MDBox>
                      {campaign.branded_materials.map((material) => (
                        <MDBox mt={1} align="left">
                          <MDBox display="flex" justifyContent="space-between" alignItems="center">
                            <MDTypography variant="h6" fontWeight="light">
                              {material.title}&nbsp;&nbsp;
                            </MDTypography>
                            <MDTypography variant="h6" fontWeight="light">
                              {material.document_type !== "LINK" ? (
                                <a href={material.material} target="_blank" rel="noreferrer">
                                  <Icon sx={{ fontWeight: "bold" }}>download</Icon>
                                </a>
                              ) : (
                                <a href={material.content} target="_blank" rel="noreferrer">
                                  <Icon sx={{ fontWeight: "bold" }}>send</Icon>
                                </a>
                              )}
                            </MDTypography>
                          </MDBox>
                        </MDBox>
                      ))}
                    </MDBox>
                  )}
                </MDBox>
              </MDTypography>
            </Container>
          </DialogContent>
          <DialogActions>
            <MDButton
              onClick={() => {
                setOpenCampaignDialog(false);
              }}
              color="dark"
              variant="outlined"
              iconOnly
              circular
            >
              <Icon sx={{ cursor: "pointer" }} fontSize="small" color="dark">
                close
              </Icon>
            </MDButton>
          </DialogActions>
        </Dialog>
      ) : (
        <> </>
      )}
      <MDBox pt={3} pb={3}>
        <Grid container spacing={6}>
          <Grid item xs={12}>
            <Grid container spacing={3}>
              <Grid item xs={12} md={12} lg={12}>
                <MDBox>
                  <Card sx={{ height: "100%", marginTop: "0px" }}>
                    <MDBox p={3}>
                      <MDBox ml={3} mr={3}>
                        <MDTypography variant="h6" fontWeight="medium">
                          My Campaigns
                        </MDTypography>
                      </MDBox>
                      <MDBox mt={5}>
                        <DataTable
                          table={{ columns: tableColumns, rows: campaigns }}
                          isSorted
                          entriesPerPage={false}
                          showTotalEntries
                          noEndBorder
                        />
                      </MDBox>
                    </MDBox>
                  </Card>
                </MDBox>
              </Grid>
            </Grid>
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}

export default MyCampaigns;
